import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core';
import { FormDateField } from '~/modules/common/components';
import { isoStringToObjectWithCache as isoStringToObject } from '~/modules/common/dates/convert';

const useV5DatePickerClasses = makeStyles(theme => ({
  input: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 'bold !important'
  }
}));

export const ResourceRequestDrawerDetailsDateField = ({
  date,
  classes,
  onChange,
  error,
  labelId
}) => {
  const { formatMessage } = useIntl();
  const v5DatePickerClasses = useV5DatePickerClasses();

  const dateProps = useMemo(
    () => ({
      inputProps: {
        'aria-label': formatMessage({
          id: labelId
        }),
        className: classes.dateField
      }
    }),
    [classes.dateField, formatMessage, labelId]
  );

  return (
    <FormDateField
      required
      editable
      InputProps={dateProps}
      label={formatMessage({
        id: labelId
      })}
      error={error}
      helperText={date.error}
      flex="shrink"
      underline={false}
      clearable={false}
      value={isoStringToObject(date.value)}
      onChange={onChange}
      useV5DatePicker
      v5DatePickerClasses={v5DatePickerClasses}
    />
  );
};

ResourceRequestDrawerDetailsDateField.propTypes = {
  date: PropTypes.object,
  classes: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  labelId: PropTypes.string,
  error: PropTypes.bool
};

export default ResourceRequestDrawerDetailsDateField;
